export default {
    // ----------Title----------
    document: 'Document',
    generateFromDeliveryOrders: 'Generate From Delivery Orders',
    scopeTheRangeOfTheCustomerProfiles: 'Scope the range of the customer profiles',
    dateRange: 'Date Range',
    documentDateforDeliveryOrders: 'Document Date for Delivery Orders',
    generateFromContainer: 'Generate From Container',
    basicInformationAboutTheDocument: 'Basic information about the document',

    cashCollection: 'Cash Collection',
    optionalForCollectionUponDelivery: 'Optional for collection upon delivery',
    hubDistribution: 'Hub Distribution',
    deliveryDistributionLocations: 'Delivery distribution locations',
    relatedProfilesAttachedToDocument: 'Related Profiles Attached To Document',

    approvalStatus: 'Approval Status',
    relatedProfileInfoAttachedToDocument: 'Related profile info attached to document',
    documentNo: 'Document No.',
    collection: 'Collection',
    distributeVia: 'Distribute Via',
    placeBy: 'Placed By',
    detailInformationAboutTheItemsInvolved: 'Detail information about the items involved',
    generateSingleInvoice: 'Generate Single Invoice',

    // -----------Drawer---------
    noPreviewInformation: 'No Preview Information',
    previewCharges: 'Preview Charges',
    no: 'No.',
    item: 'Item',
    particulars: 'Particulars',
    itemRate: 'Item Rate',
    chargeAmount: 'Charge Amount',
    shippingRates: 'Shipping Rates',
    totalSelected: 'Total Selected',
    documents: 'Documents',
    generateInvoiceNow: 'Generate Invoice Now',
    savedValidation: 'Saved Validation',
    newValidation: 'New Validation',
    addNewValidation: 'Add New Validation',
    viewSavedValidation: 'View Saved Validation',
    inventory: 'Inventory',
    slot: 'Slot',
    rack: 'Rack',
    availableQty: 'Available Qty',
    batchNo: 'Batch No.',
    expiryDate: 'Expiry Date',
    storage: 'Storage',

    // -----------MUI-----------
    docNo: 'Doc No.',
    docDate: 'Doc Date',
    doNumber: 'DO Number',
    invoiceNo: 'Invoice No.',
    billingName: 'Billing Name',
    billingAddress: 'Billing Address',
    date: 'Date',
    lastValidated: 'Last Validated',
    validation: 'Validation',
    generateFromDO: 'Generate From DO',
    documentDateFrom: 'Document Date From',
    documentDateTo: 'Document Date To',
    code: 'Code',
    qty: 'Qty',
    startQuery: 'Start Query',
    loadFrom: 'Load From...',
    billTo: 'Bill to',
    shipTo: 'Ship To',
    subTotal: 'Sub Total',
    total: 'Total',
    tax: 'Tax',
    discount: 'Discount',
    taxAmount: 'Tax Amount',
    totalAmount: 'Total Amount',
    requiredAmount: 'Required Amount',
    collectedAmount: 'Collected Amount',
    distributionLocation: 'distributionLocation',
    generateInvoices: 'Generate Invoices',
    marking: 'Marking',
    validated: 'Validated',
    pending: 'Pending',
    balance: 'Balance',
    createdItemReceive: 'Created Item Receive:',
    containerLocation: 'Container Location',
    documentLocation: ' Document Location',
}